import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="safe-pt grid min-h-screen place-items-center bg-cream px-6">
      <div className="w-full max-w-md rounded-3xl border border-ink/10 bg-panel p-10 text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto mb-5 h-10 w-10 text-ink-soft" />
        <h1 className="font-serif text-3xl font-light text-ink">Pagamento annullato</h1>
        <p className="mt-2 text-sm text-ink-soft">Nessun addebito è stato effettuato. Il tuo carrello è ancora lì ad aspettarti.</p>
        <Link to="/" data-testid="back-to-shop" className="mt-6 inline-block rounded-full bg-ink px-6 py-3 text-sm font-semibold text-cream hover:bg-electric-deep">Torna al carrello</Link>
      </div>
    </div>
  );
}
